import React, { useEffect, useState } from "react";
import "./HRAdmin.css";

import { useSelector } from "react-redux";
import { BASE_URL, FetchStaff, STAFF_ROLE } from "../../utils/constant";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import HeadStaffModel from "./headStaffModel";
import BoForm from "./boForm";
function HRAdmin() {
  const [AttendanceHeadsData, setAttendanceHeadsData] = useState(null);
  const [formVisible, setFormVisible] = useState(false);
  const [formVisibleBo, setFormVisibleBo] = useState(false);
  const capitalizeFirstLetter = (str) => {
    return str?.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const userInfo = useSelector((state) => state.signUp.signUpDetails);
  console.log("userInfoo ", userInfo);
  const showForm = (item) => {
    console.log("open");
    setFormVisible(true);
  };
  const hideForm = (item) => {
    console.log("open");
    setFormVisible(false);
    getStaffList();
  };
  const showFormBo = (item) => {
    console.log("open");
    setFormVisibleBo(true);
  };
  const hideFormBo = (item) => {
    console.log("open");
    setFormVisibleBo(false);
  };
  useEffect(() => {
    getStaffList();
  }, []);
  const getStaffList = async () => {
    const token = localStorage.getItem("authToken");

    try {
      const fetchData = async () => {
        const response = await fetch(`${BASE_URL}/${FetchStaff}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({ roles: [STAFF_ROLE.AttendanceHeads] }),
        });

        if (response.ok) {
          const data = await response.json();
          const activeStaff = data.data.filter((item) => item.isActive);
          setAttendanceHeadsData(activeStaff);
        } else {
          const data = await response.json();
          console.log("departmenterr", data);
          toast.error(data.errorMessage, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      };
      await fetchData();
    } catch (error) {
      console.error("Error updating designation:", error);
    }
  };
  return (
    <div>
      <div className="mt-2">
        <p className="text-sm text-[#00305F] font-sbold">
          HR heads have the same right to the attendance module as the BO
          (Bussiness Owner). They can manage the attendance team instead of the
          BO, and can only access the Attendance module completely.
        </p>
      </div>
      <div className="!mt-3">
        <div className="flex justify-between items-center !mt-5 !mb-2">
        <p className="text-sm text-[#4B8AEB] font-sbold !mb-2">
          Business Owner (BO)
        </p>
        {userInfo?.userRole == "businessOwner" && (
          <button
            className="h-[35px] border !border-[#00305F] px-6 inline-flex items-center rounded-full font-sbold hover:bg-[#00305F] hover:text-white cursor-pointer transition-all"
            onClick={() => showFormBo()}
          >
            Update BO
          </button>
        )}
      </div>
        <div className="bg-[#EDF0F4] rounded-[20px] !p-4">
          <div className="text-center bg-[#D8DEE7] rounded-[20px] w-56 !py-4">
            <div className="!mb-2 !table !mx-auto">
              {userInfo && userInfo?.userRole == "businessOwner" ? (
                <img
                  className="w-[70px] h-[70px] rounded-full"
                  src={`${userInfo?.logo}?${new Date().getTime()}`}
                  alt=""
                />
              ) : (
                <img
                  className="w-[70px] h-[70px] rounded-full"
                  src={userInfo?.boOwner?.logo}
                  alt=""
                />
              )}
            </div>
            <div className="text-lg font-sbold leading-none">
              {userInfo?.userRole == "businessOwner" ? (
                <p>
                  {capitalizeFirstLetter(userInfo?.firstName)}{" "}
                  {capitalizeFirstLetter(userInfo?.lastName)}
                </p>
              ) : (
                <p>
                  {capitalizeFirstLetter(userInfo?.boOwner?.firstName)}{" "}
                  {capitalizeFirstLetter(userInfo?.boOwner?.lastName)}
                </p>
              )}
            </div>
            <div className="text-sm font-sbold !mb-4">Business Owner</div>
          </div>
        </div>
      </div>
      <div className="flex justify-between items-center !mt-5 !mb-2">
        <p className="text-sm text-[#4B8AEB] font-sbold">Attendance Heads</p>
        {userInfo?.userRole == "businessOwner" && (
          <button
            className="h-[35px] border !border-[#00305F] px-6 inline-flex items-center rounded-full font-sbold hover:bg-[#00305F] hover:text-white cursor-pointer transition-all"
            onClick={() => showForm()}
          >
            + Add more
          </button>
        )}
      </div>
      <div className="bg-[#EDF0F4] rounded-[20px] !p-4">
        <div className="flex flex-wrap">
          {AttendanceHeadsData?.map((data, index) => (
            <div className="!mr-4 mb-2 bg-[#D8DEE7] !p-4 rounded-[21px] !pr-10">
              <div className="flex items-center">
                <div>
                  <img
                    className="min-w-[70px] w-[70px] h-[70px] rounded-full"
                    src={data?.faceRegisterUrl || data?.logo}
                    alt=""
                  />
                </div>
                <div className="pl-3">
                  <p className="font-sbold">
                    {capitalizeFirstLetter(data?.firstName)}{" "}
                    {capitalizeFirstLetter(data?.lastName)}
                  </p>
                  <p className="text-sm">
                    {capitalizeFirstLetter(data?.designation?.designationName)}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <p className="text-sm text-[#00305F] !mt-2">
          Finance Heads have the same rights as BO but they all report to BO
          and, cannot remove/edit the BO
        </p>
      </div>

      <BoForm
        open={formVisibleBo}
        onCancel={hideFormBo}
      />
      <HeadStaffModel
        open={formVisible}
        onCancel={hideForm}
        isAttendanceHead={true}
      />
    </div>
  );
}

export default HRAdmin;
